import TrainingByStore from './TrainingByStore';
export default TrainingByStore;